import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { settings } from '../../../settings';
import { addNewAccountType } from '../../models/Interfaces/addNewAccount';

@Injectable({
  providedIn: 'root',
})
export class AddNewAccountService {
  api = settings.API_URL;
  constructor(private http: HttpClient) {}

  addnewAccount(params: addNewAccountType): Observable<any> {
    return this.http.post(this.api + '/api/login/createCompanyLogin', params, {
      responseType: 'text',
    });
  }

  searchByNameAndEMail(params: any): Observable<any> {
    let apiUrl: any;
    if (params.companyName) {
      apiUrl =
        this.api +
        `/api/companyInfo/searchByNameAndEMail?companyName=${params.companyName}`;
    } else {
      apiUrl =
        this.api +
        `/api/companyInfo/searchByNameAndEMail?companyEMail=${params.companyEMail}`;
    }
    return this.http.get(apiUrl);
  }
}
